/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpArrowDownV: {
  name: 'arrow-up-arrow-down-v';
  data: string;
} = {
  name: 'arrow-up-arrow-down-v',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 4a1 1 0 0 0-2 0v13l-1.2-1.6a1 1 0 1 0-1.6 1.2l3 4a1 1 0 0 0 1.6 0l3-4a1 1 0 0 0-1.6-1.2L7 17V4Zm11.8-.6a1 1 0 0 0-1.6 0l-3 4a1 1 0 1 0 1.6 1.2L17 7v13a1 1 0 1 0 2 0V7l1.2 1.6a1 1 0 0 0 1.6-1.2l-3-4Z" fill="currentColor"/></svg>`,
};
